export default {"src":"https://cdn.jetlend.ru/_next/static/media/clock-icon.d42104e9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};